var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1001_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.492 39.9219H94.6094V64.5312H34.4531V94.6094C34.4531 97.63 36.9012 100.078 39.9219 100.078V119.492C39.9219 130.819 49.1034 140 60.4297 140H79.5703C90.8966 140 100.078 130.819 100.078 119.492V108.281H75.5852C73.3764 108.281 71.476 106.584 71.3716 104.378C71.2603 102.022 73.138 100.078 75.4688 100.078H119.492C130.819 100.078 140 90.8966 140 79.5703V60.4297C140 49.1034 130.819 39.9219 119.492 39.9219Z",
    fill: "#FEEF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.492 39.9219H94.6094V64.5312H70V140H79.5703C90.8966 140 100.078 130.819 100.078 119.492V108.281H75.5852C73.3764 108.281 71.476 106.584 71.3716 104.378C71.2603 102.022 73.138 100.078 75.4688 100.078H119.492C130.819 100.078 140 90.8966 140 79.5703V60.4297C140 49.1034 130.819 39.9219 119.492 39.9219Z",
    fill: "#FEDC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8594 70H89.1406C95.1809 70 100.078 65.1027 100.078 59.0625V20.5078C100.078 9.1998 90.8783 0 79.5703 0H60.4297C49.1217 0 39.9219 9.1998 39.9219 20.5078V31.7188H64.5312C66.7967 31.7188 68.6328 33.5549 68.6328 35.8203C68.6328 38.0857 66.7967 39.9219 64.5312 39.9219H20.5078C9.1998 39.9219 0 49.1217 0 60.4297V79.5703C0 90.8783 9.1998 100.078 20.5078 100.078H39.9219V80.9375C39.9219 74.8973 44.8191 70 50.8594 70Z",
    fill: "#78E0EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5703 0H70V70H89.1406C95.1809 70 100.078 65.1027 100.078 59.0625V20.5078C100.078 9.1998 90.8783 0 79.5703 0Z",
    fill: "#3CCCDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5312 16.6797C64.5312 18.9451 62.6951 20.7812 60.4297 20.7812C58.1643 20.7812 56.3281 18.9451 56.3281 16.6797C56.3281 14.4143 58.1643 12.5781 60.4297 12.5781C62.6951 12.5781 64.5312 14.4143 64.5312 16.6797Z",
    fill: "#5A5A6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6719 123.32C83.6719 125.586 81.8357 127.422 79.5703 127.422C77.3049 127.422 75.4688 125.586 75.4688 123.32C75.4688 121.055 77.3049 119.219 79.5703 119.219C81.8357 119.219 83.6719 121.055 83.6719 123.32Z",
    fill: "#46465A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1001_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.a0bd86216d583418fd0336872a54d1a6.svg";
export { ForwardRef as ReactComponent };